export interface Frontmatter {
  [key: string]: string | boolean | string[];
}

export function parseFrontmatter(content: string): { frontmatter: Frontmatter; body: string } {
  const match = content.match(/^---\n([\s\S]*?)\n---\n([\s\S]*)$/);
  if (!match) {
    throw new Error('Invalid frontmatter format');
  }

  const [, frontmatterStr, body] = match;
  const frontmatter: Frontmatter = Object.fromEntries(
    frontmatterStr.split('\n')
      .filter(Boolean)
      .map(line => {
        const [key, ...values] = line.split(':');
        let value: string | boolean | string[] = values.join(':').trim();

        if (value.startsWith('"') && value.endsWith('"')) {
          value = value.slice(1, -1);
        } else if (value === 'true') {
          value = true;
        } else if (value === 'false') {
          value = false;
        } else if (value.startsWith('[') && value.endsWith(']')) {
          try {
            value = JSON.parse(value);
          } catch {
            value = value.toString();
          }
        }

        return [key.trim(), value];
      })
  );

  return { frontmatter, body };
}
